"use client"

import { motion, useInView } from "framer-motion"
import { headingVariants, standardScrollConfig } from "@/utils/animations"
import { cn } from "@/lib/utils"

export default function SectionHeader({
  children,
  ref,
  className,
}: {
  children: React.ReactNode
  ref: React.RefObject<HTMLElement>
  className?: string
}) {
  const isInView = useInView(ref, standardScrollConfig)

  return (
    <motion.h2
      className={cn(
        "font-ivyora flex-1 tracking-tight text-wood text-4xl md:text-5xl lg:text-6xl max-w-2xl text-center mx-auto",
        className
      )}
      variants={headingVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      {children}
    </motion.h2>
  )
}
